import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import BeforeAfter from "../components/BeforeAfter";
import LearnMore from "../components/LearnMore";
import useSEO from "../hooks/useSEO";

export default function PrimaDopo() {
  useSEO({
    title: "Prima e dopo | Dentalchivasso — Risultati reali di implantologia a carico immediato",
    description:
      "Risultati reali di implantologia a carico immediato a Chivasso: denti fissi definitivi in 6 ore, casi prima e dopo, € 5.900 con preventivo confermato dopo la prima visita con TAC 3D.",
    path: "/prima-e-dopo",
  });

  return (
    <div data-testid="prima-e-dopo-page">
      <div className="bg-sand/70 border-b border-line">
        <div className="max-w-7xl mx-auto px-5 md:px-8 pt-32 pb-16 md:pt-40 md:pb-20">
          <div className="grid lg:grid-cols-2 gap-10 items-end">
            <Reveal>
              <Eyebrow>Prima e dopo · Carico immediato</Eyebrow>
              <h1 className="mt-5 font-display font-medium tracking-tight text-ink text-4xl md:text-5xl leading-[1.08]">
                Denti fissi definitivi, <span className="italic text-teal">in 6 ore.</span>
              </h1>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-mutedc leading-relaxed max-w-xl">
                Quando le condizioni cliniche lo permettono, applichiamo una protesi provvisoria
                o definitiva sulle nuove radici implanto-supportate già in 6 ore dall'intervento,
                dopo una visita specialistica e diagnosi radiologiche: un solo percorso chirurgico,
                senza mesi di attesa.
              </p>
              <ul className="mt-6 space-y-3">
                {[
                  "Denti fissi in 6 ore, se le condizioni lo consentono",
                  "Possibilità di richiedere, con un piccolo sovraprezzo, la protesi su impianti definitiva in ceramica nano ibrida",
                ].map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm text-ink/80">
                    <Check size={16} className="text-teal mt-0.5 shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="bg-ivory">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 md:py-28">
          <div className="grid lg:grid-cols-12 gap-8 items-center">
            <Reveal className="lg:col-span-5">
              <BeforeAfter before="/risultati-prima.jpg" after="/risultati-dopo.jpg" />
              <p className="mt-4 text-center text-xs text-mutedc">Caso 1 — risultato reale di implantologia a carico immediato. Trascina per confrontare.</p>
            </Reveal>
            <Reveal delay={0.08} className="lg:col-span-7">
              <BeforeAfter before="/risultati2-prima.jpg" after="/risultati2-dopo.jpg" aspect="aspect-[8/5]" />
              <p className="mt-4 text-center text-xs text-mutedc">Caso 2 — risultato reale di implantologia a carico immediato. Trascina per confrontare.</p>
            </Reveal>
          </div>

          <div className="mt-12 grid lg:grid-cols-12 gap-8 items-center">
            <Reveal className="lg:col-span-4">
              <img
                src="/carico-immediato-flyer.jpg"
                alt="Carico immediato: denti fissi in tempi ridotti, quando è possibile. Messaggio informativo sanitario Dentalchivasso"
                className="rounded-[2rem] w-full border border-line shadow-soft"
                data-testid="carico-flyer"
              />
              <p className="mt-4 text-center text-xs text-mutedc">Messaggio informativo sanitario</p>
            </Reveal>
            <Reveal delay={0.12} className="lg:col-span-8">
              <div className="flex flex-wrap items-center gap-6">
                <div className="inline-flex items-baseline gap-3 rounded-2xl bg-paper border border-line px-7 py-5" data-testid="price-immediate-loading">
                  <span className="font-display text-5xl font-semibold text-teal">€ 5.900</span>
                  <span className="text-xs text-mutedc max-w-[180px] leading-snug">implantologia a carico immediato, preventivo confermato dopo prima visita con TAC</span>
                </div>
                <Link
                  to="/contatti"
                  data-testid="prima-dopo-cta"
                  className="group inline-flex items-center gap-2 rounded-full bg-ink text-ivory font-semibold text-sm px-7 py-4 hover:bg-teal transition-colors duration-300"
                >
                  Prenota una consulenza
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </Reveal>
          </div>

          <div className="mt-10 text-center">
            <LearnMore to="/servizi#implantologia" testid="learn-more-prima-dopo" />
          </div>
        </div>
      </div>
    </div>
  );
}
